export default function Footer() {
  const footerLinks = [
    {
      title: '阅读方式',
      links: [
        { label: '下拉式阅读', href: '#features' },
        { label: '弹窗阅读', href: '#features' },
        { label: '翻页阅读', href: '#features' },
        { label: '高清显示', href: '#features' },
      ],
    },
    {
      title: '热门分类',
      links: [
        { label: '韩漫推荐', href: '#cards' },
        { label: '日漫精选', href: '#cards' },
        { label: '热血少年', href: '#topics' },
        { label: '恋爱甜宠', href: '#topics' },
      ],
    },
    {
      title: '快速入口',
      links: [
        { label: '精选推荐', href: '#cards' },
        { label: '焦点专题', href: '#carousel' },
        { label: '热度榜单', href: '#ranking' },
        { label: '最新更新', href: '#updates' },
      ],
    },
    {
      title: '帮助中心',
      links: [
        { label: '常见问题', href: '#faq' },
        { label: '关于我们', href: '#about' },
        { label: '联系我们', href: '#contact' },
      ],
    },
  ];

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const id = href.replace('#', '');
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-18">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          <div className="col-span-2 md:col-span-1">
            <span className="font-heading text-2xl text-primary-400 whitespace-nowrap">
              YY漫画
            </span>
            <p className="mt-3 text-sm text-foreground-400 leading-relaxed">
              YY漫画是免费漫画阅读平台，提供下拉式阅读、弹窗阅读、翻页阅读三种模式，支持高清显示，汇集海量韩漫、日漫全集资源，让你随时随地追更收藏喜欢的作品。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#contact" onClick={(e) => handleClick(e, '#contact')} className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 transition-colors cursor-pointer">
                <i className="ri-mail-line text-sm"></i>
              </a>
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </span>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-bold text-sm text-background-100 mb-4 whitespace-nowrap">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => handleClick(e, link.href)}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/60">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex flex-wrap items-center gap-1 text-xs text-foreground-500">
              <span>合作伙伴</span>
            </div>
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} YY漫画 - 免费漫画阅读器，本页内容仅供展示
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}